<template>
  <div>
    <Header v-if="!$route.meta?.hideNavbar"/>
    <router-view />
  </div>
</template>

<script>
import { mapStores } from 'pinia';
import './App.scss';
import Header from '@/components/Header.vue';
import useApiStore from '@/stores/api';

export default {
  name: 'App',
  components: {
    Header,
  },
  computed: {
    ...mapStores(useApiStore),
  },
};
</script>
